import { Button, Flex, Grid, Heading, Paragraph } from '@zillow/constellation';
import type { UserStatus } from '../../../graphql/queries';
import { BackgroundReportAlertSmall, isBackgroundCheckViewable } from '../BackgroundReport/BackgroundReportAlert';
import { getIsBackgroundReportValid } from '../../../utils/user-statuses';
import type { BackgroundReport } from '@zg-rentals/ts-capps-client';

export function BackgroundReportOverview({
  backgroundReport,
  userStatuses,
  onView,
}: {
  backgroundReport?: BackgroundReport;
  userStatuses: Array<UserStatus>;
  onView: () => void;
}) {
  const isBackgroundReportValid = getIsBackgroundReportValid(userStatuses);
  const backgroundReportVisible = isBackgroundCheckViewable(backgroundReport);

  const evictionCount = backgroundReport?.evictionReport?.records
    ? backgroundReport?.evictionReport?.records.length
    : '0';
  const criminalCount = backgroundReport?.criminalReport?.records
    ? backgroundReport?.criminalReport?.records.length
    : '0';

  return (
    <Flex display="flex" justifyContent="space-between" alignItems="start">
      <Flex display="flex" flexDirection="column" gap="xs">
        <Heading level={6} as="h2">
          Background check
        </Heading>
        <BackgroundReportAlertSmall backgroundReport={backgroundReport} />

        <Grid display="grid" gridTemplateColumns="repeat(2, 1fr)" gap="sm">
          <Grid gridColumnEnd={{ default: 'span 2', md_gte: 'span 1' }}>
            <Flex display="flex" flexDirection="column" gap="xs">
              <Heading level={6} as="h3" fontColor="textMedium" fontType="bodySmall">
                {Number(evictionCount) === 1 ? 'Housing court record' : 'Housing court records'}
              </Heading>
              <Paragraph>
                <strong>{isBackgroundReportValid && backgroundReportVisible ? evictionCount : '-'}</strong>
              </Paragraph>
            </Flex>
          </Grid>
          <Grid gridColumnEnd={{ default: 'span 2', md_gte: 'span 1' }}>
            <Flex display="flex" flexDirection="column" gap="xs">
              <Heading level={6} as="h3" fontColor="textMedium" fontType="bodySmall">
                {Number(criminalCount) === 1 ? 'Criminal record' : 'Criminal records'}
              </Heading>
              <Paragraph>
                <strong>{isBackgroundReportValid && backgroundReportVisible ? criminalCount : '-'}</strong>
              </Paragraph>
            </Flex>
          </Grid>
        </Grid>
      </Flex>
      <Button
        size="sm"
        onClick={onView}
        disabled={!isBackgroundReportValid || !backgroundReportVisible}
        type="button"
        aria-label="View background check"
      >
        View
      </Button>
    </Flex>
  );
}
